import {createSlice} from '@reduxjs/toolkit'
const filterManageListingProductCondition = createSlice({
  name: 'filterManageListingProductCondition',
  initialState: 'new' as string,
  reducers: {
    manageListingProductConditionFilterdata(state: any, action: any) {
      return action?.payload || 'new'
    },
  },
})
export default filterManageListingProductCondition.reducer
export const {manageListingProductConditionFilterdata} = filterManageListingProductCondition.actions
